export default function () {
    return {
        question: {
            question: null,
            answer: null
        },
        success: false,
        customToolbar: [
            ["bold", "italic", "underline"],
            [
                {list: "ordered"},
                {list: "bullet"}
            ],
            ["image"],
            [{ 'size': ['small', false] }]
        ],
        errors: {
            question: null,
            answer: null
        }
    }
}
